import type { Provider, Type } from '@angular/core';

import {
  type ChatPresenterComponent,
  provideTellentAssistantRenderPresenter,
} from '@core/tellent-assistant-contracts';

import {
  PresentCandidatesComponent,
  PresentEvaluationsComponent,
  PresentEventsComponent,
  PresentJobsComponent,
  PresentLinksComponent,
  PresentRequisitionsComponent,
  PresentTalentPoolsComponent,
  PresentTasksComponent,
  PresentTeamMembersComponent,
} from '../present-list/kinded-presenters.component';

const provide = (id: string, component: Type<ChatPresenterComponent<unknown>>): Provider =>
  provideTellentAssistantRenderPresenter({ useValue: { id, component } });

export const providePresentCandidatesClientTool = provide(
  'presentCandidates',
  PresentCandidatesComponent,
);
export const providePresentTeamMembersClientTool = provide(
  'presentTeamMembers',
  PresentTeamMembersComponent,
);
export const providePresentJobsClientTool = provide('presentJobs', PresentJobsComponent);
export const providePresentTalentPoolsClientTool = provide(
  'presentTalentPools',
  PresentTalentPoolsComponent,
);
export const providePresentLinksClientTool = provide('presentLinks', PresentLinksComponent);
export const providePresentEventsClientTool = provide('presentEvents', PresentEventsComponent);
export const providePresentEvaluationsClientTool = provide(
  'presentEvaluations',
  PresentEvaluationsComponent,
);
export const providePresentTasksClientTool = provide('presentTasks', PresentTasksComponent);
export const providePresentRequisitionsClientTool = provide(
  'presentRequisitions',
  PresentRequisitionsComponent,
);
